<template>
    <div>
        <PreviewTimesheet :key="eventcount"></PreviewTimesheet>
    </div>
</template>
<script>
import PreviewTimesheet from 'components/timesheet/PreviewTimesheet'
import { mapGetters } from 'vuex'

export default {
    components: {
        PreviewTimesheet
    },
    computed: {
      ...mapGetters(['eventcount'])
    }
}
</script>



// WEBPACK FOOTER //
// Preview.vue?4173b0e2